import React, { FC } from 'react';
import classlist from 'utils/classlist';

import './style.scss';

interface MarketTagProps {
    market: string;
}

const MarketTag: FC<MarketTagProps> = props => {
    return <span className={classlist('market-tag', `market-tag-${props.market}`)}>{props.market}</span>;
};

export default MarketTag;
